module.exports = __webpack_public_path__ + "dashboard/img/otwarte-wieloodp-12.a6f1fe48561e0cdb7e77a90bc790fad2.svg";